module.exports = __webpack_public_path__ + "static/media/Jhin_0.e929ddfb.png";